import { SectionStyleType } from '@varo/graphql-schema-types';
import { sectionHeaderOnPress } from 'features/rewards/helpers/DetermineDestination.helpers';
import React from 'react';
import { Pressable } from 'react-native';
import SectionDivider from 'shared/components/vxl/divider/SectionDivider/SectionDivider';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';
import { usePressableAnalytics } from 'shared/hooks/analytics/usePressableAnalytics';
import theme from 'shared/styles/theme';

export interface PressableSectionHeaderProps {
  sectionId: string;
  sectionName: string;
  sectionStyle: SectionStyleType;
  hasNext: boolean;
}

export const PressableSectionHeaderV2 = ({
  sectionId,
  sectionName,
  sectionStyle,
  hasNext,
}: PressableSectionHeaderProps) => {
  const headerPressAnalytics = usePressableAnalytics({
    analyticsId: 'nearbyMapSelected',
  });

  const isNearbySection = sectionStyle === SectionStyleType.NearbySection;

  const trailingItem: IconProps | undefined =
    hasNext || isNearbySection
      ? {
          iconKey: 'CHEVRON_RIGHT',
          iconAccessibilityLabel: 'chevron-right-icon',
        }
      : undefined;

  const handleOnPress = () => {
    if (hasNext || isNearbySection) {
      if (isNearbySection) {
        headerPressAnalytics();
      }
      sectionHeaderOnPress(sectionId, sectionName, sectionStyle);
    }
  };

  return (
    <Pressable onPress={handleOnPress}>
      <SectionDivider
        labelText={sectionName}
        trailingItemType={hasNext || isNearbySection ? 'icon' : undefined}
        trailingItem={trailingItem}
        background={theme.color.background.tertiary}
        textSize="large"
      />
    </Pressable>
  );
};
